<template>
  <md-toolbar class="nav-bar">
    <img
      v-if="productType !== 'NURSING'"
      class="md-title vrp-logo"
      :src="logo"
      alt="VRP logo"
    >
    <img
      v-else
      class="md-title vrp-logo vrp-logo-nursing"
      :src="logo"
      alt="VRP logo"
    >
    <div class="user-account-container">
      <div class="user-name-container vertical centered">
        <a href="/auth/account/profile" class="user-name">{{ userName }}</a>
        <org-selector :compact="true" @orgChange="onOrgChange">
          <template slot="trigger">
            <span md-menu-trigger class="org-name" @click="toggleOrgSelection">
              {{ organizationName }}
              <md-icon class="org-dropdown">arrow_drop_down</md-icon>
            </span>
          </template>
          <template slot="after-menu">
            <md-menu-item
              @click="logout()"
            >
              <span>Logout</span>
              <md-icon>logout</md-icon>
            </md-menu-item>
          </template>
        </org-selector>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import get from 'lodash/get';
import OrgSelector from '../OrgSelector';

export default {
  name: 'nav-bar',
  components: {
    OrgSelector,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      state: {
        orgSelectionOpen: false,
      }
    };
  },
  computed: {
    userName() {
      return `${this.user.given_name || ''} ${this.user.family_name || ''}`;
    },
    organizationName() {
      const groupsData = this.user['https://vrpatients.com/groupsData'];
      return get(groupsData, '[0].name', '');
    },
    productType() {
      return this.user['https://vrpatients.com/productType'];
    },
    logo() {
      return require(`../../assets/images/VRP_Logo_${this.productType}.png`);
    }
  },
  methods: {
    logout() {
      this.$emit('logout');
      this.$analytics.event('Login', 'logout', this.user.email);
    },
    toggleOrgSelection() {
      this.state.orgSelectionOpen = !this.state.orgSelectionOpen;
    },
    onOrgChange() {
      window.location.reload();
    },
  },
};
</script>


<style scoped>
.nav-bar {
  width: 100%;
  height: 88px;
  /* Prevent flex from squashing the nav bar */
  min-height: 88px;
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.35);
  background-color: #303243;
  padding-right: 0;
  display: flex;
  justify-content: space-between;
}
.vrp-logo {
  max-height: 75%;
  margin-left: 16px;
}
.vrp-logo-nursing {
  padding: 6px 6px 6px 0;
}

.nav-bar .user-account-container {
  height: 100%;
  display: flex;
}
.nav-bar .user-name-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 10px;
}

.nav-bar .menu-button {
  height: 100%;
}

.user-name, .org-name {
  align-self: start;
  text-transform: none;
}
.user-name {
  font-size: 18px;
  font-weight: 500;
  color: #2595d3;
  text-decoration: underline;
}
.org-name {
  font-size: 14px;
  font-weight: normal;
  color: white;
  cursor: pointer;
}
.org-dropdown {
  color: white !important;
}
</style>

<style>
.nav-bar .menu-button.logout .md-ripple {
  padding-right: 18px;
  padding-left: 18px;
}
</style>
